export const styles = {
	avatar: {
		margin: 0,
		backgroundColor: 'primary.main'
	}
};
